export class CounterHoliday {
  public date: Date;
  public isOpen: boolean;

  public constructor(date: Date, isOpen: boolean) {
    this.date = date;
    this.isOpen = isOpen;
  }
}
